import React from "react";
import ReactDOM from "react-dom/client";
import "./Utils/toastUtils";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import { Provider } from "react-redux";
import { store } from "./App/store";
import { registerChunkLoadErrorHandler } from "./Utils/chunkLoadErrorHandler";

registerChunkLoadErrorHandler();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const CustomCloseButton = ({
  closeToast,
}: {
  closeToast: (e: any) => void;
}) => (
  <div className="flex flex-col justify-between items-end h-full pb-1.5 pl-1 absolute top-0 left-0 toast-close-box">
    <CloseIcon onClick={closeToast} />
    <div
      className="close-all-icon text-gray-600 text-xs"
      onClick={() => toast.dismiss()}
    >
      بستن همه
    </div>
  </div>
);

{/* <React.StrictMode> */}
root.render(
    <BrowserRouter>
      <Provider store={store}>
        <App />
        <ToastContainer
          closeButton={CustomCloseButton}
          position="bottom-center"
          autoClose={5000}
          rtl
        />
      </Provider>
    </BrowserRouter>
);
  {/* </React.StrictMode> */}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
